module.exports = __webpack_public_path__ + "img/dbe5f.bd9c577e.svg";